import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Use localStorage as the default storage
import NOBMasterReducer from "@/redux/slice/NobSlice";
import authReducer from "@/redux/slice/authSlice";
import CurrencyMasterReducer from "@/redux/slice/CurrencyMasterSlice";
import CommonMasterReducer from "@/redux/slice/commonMasterSlice";
import BranchMasterReducer from "@/redux/slice/branchMasterSlice";
import EmployeeMasterReducer from "@/redux/slice/EmployeeSlice";
import CountryMasterReducer from "@/redux/slice/CountryMasterSlice";
import UploadSliceReducer from "@/redux/slice/UploadSlice";
import CorporateFileUploadSliceReducer from "@/redux/slice/CorporateFileUploadSlice";
import dealerCategoryReducer from "@/redux/slice/authorizedDealerSlice";
import functionalReducer from "@/redux/slice/functionalSlice";
import roleReducer from "@/redux/slice/roleSlice";
import tenantReducer from "@/redux/slice/tenantSlice";
import VendorMasterReducer from "@/redux/slice/VendorSlice";
import RateMasterReducer from "@/redux/slice/RateMasterSlice";
import routerReducer from "@/redux/slice/routerSlice";
import IndividualReducer from "@/redux/slice/IndividualMasterSlice";
import branchReducer from '@/redux/slice/branchSlice'
import StateReducer from '@/redux/slice/StateMasterSlice';
import SalesReducer from '@/redux/slice/saleFormSlice';
import CorporateMasterReducer from "@/redux/slice/commonCorperate"; 
import FinancialYearReducer from "@/redux/slice/financialyearSlice";
import PurchaseReducer from "@/redux/slice/purchaseFormSlice"
import ProductMasterReducer from "@/redux/slice/ProductMasterSlice";
import VTMReducer from "@/redux/slice/VTMSlice"
import {invoiceReducer,invoiceTabReducer} from '@/redux/slice/invoiceSlice'
import ledgerMasterReducer from '@/redux/slice/LedgerSlice'
import {saleInvoiceReducer,saleInvoiceTabReducer} from '@/redux/slice/saleInvoiceSlice'
import reportReducer from '@/redux/slice/reportSlice'
import reportFeatureReducer from "@/redux/slice/reportfeatureSlice";
import permissionsreducer from '@/redux/slice/buttonpermissionSlice';
import notificationReducer from "@/redux/slice/notificationSlice"; 

const rootReducer = combineReducers({
  nobMaster: NOBMasterReducer,
  auth: authReducer,
  dealerCategory: dealerCategoryReducer,
  roles: roleReducer,
  tenant: tenantReducer,
  functional: functionalReducer,
  currencyMaster: CurrencyMasterReducer,
  commonMaster: CommonMasterReducer,
  branchMaster: BranchMasterReducer,
  EmployeeMaster: EmployeeMasterReducer,
  CountryMaster: CountryMasterReducer,
  uploadMaster: UploadSliceReducer,
  corpUploadAsyncMaster: CorporateFileUploadSliceReducer,
  VendorMaster: VendorMasterReducer,
  RateMaster: RateMasterReducer,
  router: routerReducer,
  IndividualProfile: IndividualReducer,
  branch: branchReducer,
  state: StateReducer,
  saleForm : SalesReducer,
  corporate: CorporateMasterReducer,
  purchaseForm:PurchaseReducer,
  financialyear:FinancialYearReducer,
  productMaster:ProductMasterReducer,
  vtmRate:VTMReducer,
  invoiceForm:invoiceReducer,
  invoiceTab:invoiceTabReducer,
  ledgerMaster:ledgerMasterReducer,
  saleInvoiceForm:saleInvoiceReducer,
  saleInvoiceTab:saleInvoiceTabReducer,
  reports: reportReducer,
  reportsfeature: reportFeatureReducer,
  button:permissionsreducer,
  notifications: notificationReducer,

});

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "auth",
    "currencyMaster",
    "commonMaster",
    "branchMaster",
    "EmployeeMaster",
    "CountryMaster",
    "VendorMaster",
    "nobMaster",
    "dealerCategory",
    "roles",
    "tenant",
    "functional",
    "router",
    "branch",
    "state",
    "corporate", 
    "financialyear",
    "productMaster",
    "ledgerMaster",
    "reports",
    "reportsfeature",
    "button",
    "notifications"
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export type RootState = ReturnType<typeof rootReducer>;

export default persistedReducer;
